module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-lighting.png?e84dda148108758586c3f7f28a3f69d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-lighting.png
// module id = 1036
// module chunks = 1